/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FileIcon, defaultStyles } from 'react-file-icon';
import {
  Close,
  Container, ContainerMessage, ContainerTitle, ExportBox, IconStatus, Line, MessageFile, NameFile, TextIcon, TitleExport, MessageName, TextIconClose, MessageItem,
} from './styles';
import Icon from '../Icon';
import Loader from '../Loader'
import Spinner, { SpinnerSize } from 'components/Spinner';

export default function useBackgroundReportExportService({ children, projectBr }) {
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [startDownload, setStartDownload] = useState(false);
  const [statusDownload, setStatusDownload] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hide, setHided] = useState(false);
  const [nameFile, setNameFile] = useState(false);
  const [reports, setReports] = useState([]);
  const [reportDownloaded, setReportDownloaded] = useState([]);
  let listAux = [];
  async function downloadFileAtUrl(url, idDocument) {
    let listDownloaded = JSON.parse(sessionStorage.getItem('texel-export-list-report-downloaded'))
    listAux = listDownloaded ? listDownloaded : []
    let downloaded = listDownloaded && listDownloaded.length > 0 ? listDownloaded.find(item => item == url) : null;
    if (!downloaded) {
      const fileName = url.split("/").pop();
      listAux.push(url)
      sessionStorage.setItem('texel-export-list-report-downloaded', JSON.stringify(listAux));
      setReportDownloaded(listAux)

      var downloader = document.createElement('a');
      downloader.href = url;
      downloader.setAttribute('download', fileName);

      downloader.style.display = 'none';
      document.body.appendChild(downloader);
      downloader.click();
      fitinsur.setAuthToken(authContext.token);
      await fitinsur.requestPutDocumentUpdateMetadata(idDocument);
      document.body.removeChild(downloader);
    }
  }

  useEffect(() => {
    setInterval(async () => {
      if (!authContext.status) {
        setStartDownload(false)
      }
      const exportInit = sessionStorage.getItem('init-texel-export-list-report');
      if (exportInit) {
        setStartDownload(true)
      }
      let exportAuthorized = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
      if (!exportAuthorized || exportAuthorized == 'undefined' || exportAuthorized.length == 0 || exportAuthorized == []) return;
      let listAux = [];

      setStartDownload(true)
      setReports(exportAuthorized)
      for (var i = 0; i < exportAuthorized.length; i++) {
        if (exportAuthorized[i].processing) {

          fitinsur.setAuthToken(authContext.token);
          const response = await fitinsur.requestGetDocumentIdMetadata(exportAuthorized[i].idDocument).then(response => response.json());
          setNameFile(response.fileName)
          setStatusDownload(false)
          if (response.ret_code !== 200 || response.ret_value == 'processing') return;
          
          exportAuthorized[i].processing = null;
          exportAuthorized[i].fileName = response.fileName;
          if (response.ret_value !== 'canceled') {
            let downloaded = JSON.parse(response.DOCUMENT_METADATA).downloaded;
            if (!downloaded) {
              await downloadFileAtUrl(response.link, response.ID_DOCUMENT)
            }
          } else {
            exportAuthorized[i].error = true;
            setHasError(true);
          }

          listAux.push(exportAuthorized[i])
          exportAuthorized = exportAuthorized.filter(item => item != exportAuthorized[i])
        }
      }
      let processingAll = exportAuthorized?.filter(item => item.processing != null);
      sessionStorage.removeItem('texel-export-list-report');
      sessionStorage.setItem('texel-export-list-report', JSON.stringify(processingAll));
      if (listAux.length > 0) setReports(listAux)


      if (!processingAll.length) {
        sessionStorage.removeItem('texel-export-list-report');
        sessionStorage.removeItem('init-texel-export-list-report');
        sessionStorage.removeItem('texel-export-list-report-downloaded');
        setHided(false)
        setStatusDownload(true)
      }
    }, 7000)
  }, [])

  return (
    <>
      {children}
      {
        startDownload ?
          <Container hide={hide}>
            <ExportBox hide={hide}>
              <ContainerTitle>
                <TitleExport>
                  {statusDownload ?
                    <IconStatus>
                      {projectBr ?
                        <>
                          {!hasError ?
                            <><Icon name="ok-green" className="icon-ok-green" />Arquivos prontos</> :
                            <>{projectBr ? 'Erro' : 'Error'}</>
                            }
                        </>
                        :
                        <>
                          {!hasError ?
                            <><Icon name="ok-green" className="icon-ok-green" />{projectBr ? 'Arquivos prontos' : 'Files are ready'}</> :
                            <>{projectBr ? 'Erro' : 'Error'}</>
                            }
                        </>
                      }
                    </IconStatus>
                    :
                    <IconStatus>
                      <Spinner size={0.5} color={'#3A5DAE'} />
                      <TextIcon>{projectBr ? 'Exportando arquivos' : 'Exporting files'}</TextIcon>
                    </IconStatus>
                  }
                </TitleExport>
                <Close>
                  {hide ?
                    <Icon name="arrowup" className="icon-arrowup" onClick={() => setHided(false)} />
                    :
                    <Icon name="arrowdown" className="icon-arrowdown" onClick={() => setHided(true)} />
                  }
                  <TextIconClose onClick={() => {
                    setStartDownload(false);
                    setHasError(false);
                    setReports([])
                    sessionStorage.removeItem('texel-export-list-report');
                    sessionStorage.removeItem('init-texel-export-list-report');
                    sessionStorage.removeItem('texel-export-list-report-downloaded');
                  }}>
                    {projectBr ?
                      <>Fechar</>
                      :
                      <>Close</>
                    }
                  </TextIconClose>
                </Close>
              </ContainerTitle>
              {!hide ?
                <>
                  <Line />
                  <ContainerMessage>
                    <MessageName>
                      {console.log(reports)}
                      {reports && reports.length && reports?.map((item, i) =>
                        <MessageItem key={i}>
                          <FileIcon extension={'xlsx'} {...defaultStyles['xlsx']} size={1} />
                          {item.error ?
                            <>
                              {projectBr ?
                                <>Occoreu um erro ao baixar o {item.fileName ? item.fileName : item.nameList}. Por favor tente novamente</>
                                :
                                <>Error downloading the {item.fileName ? item.fileName : item.nameList}. Please try again</>
                              }</>
                            : !item.processing ?
                              <>
                                {projectBr ?
                                  <>Pronto, {item.fileName} foi completamente baixado</>
                                  :
                                  <>Done, {item.fileName} downloaded succesfully</>
                                }</>
                              :
                              <>{projectBr ?
                                <>Um momento, exportando {item.fileName ? item.fileName : item.nameList}</>
                                :
                                <>Just a moment, exporting {item.fileName ? item.fileName : item.nameList}</>
                              }</>
                          }
                        </MessageItem>
                      )
                      }
                    </MessageName>
                  </ContainerMessage>
                </> : <></>
              }
            </ExportBox>
          </Container>
          : null
      }
    </>
  )
}